export default __webpack_public_path__ + "static/media/jquery.8fde60d0.svg";